import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface LearnMoreProps {
  title: string;
  children: React.ReactNode;
}
export const LearnMore: React.FC<LearnMoreProps> = ({
  title,
  children
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="mt-4 print:hidden" data-id="element-397">
      <button onClick={() => setIsExpanded(!isExpanded)} className="flex items-center justify-center space-x-2 text-sm text-[#C00000] hover:text-[#C00000]/80 transition-colors font-medium w-full" type="button" data-id="element-398">
        <span data-id="element-399">{title}</span>
        {isExpanded ? <ChevronUpIcon className="h-4 w-4" data-id="element-400" /> : <ChevronDownIcon className="h-4 w-4" data-id="element-401" />}
      </button>
      <AnimatePresence data-id="element-402">
        {isExpanded && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-403">
            <div className="mt-3 p-4 bg-[#F9FAFB] rounded-sm border border-[#E5E5E5] text-sm text-[#000000] leading-relaxed" data-id="element-404">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};